
const pairOption = {
  "PP Bag": "in single new polypropylene bags of",
  "PE Bag": "in new single polyethylene bags of",
  "Inner PE Outer PE Bag" : "in double bags (inner : plastic and outer : plastic) of",
  "In Bulk": "in bulk",
  "Inner PE Outer PP Bag": "in double bags (inner : plastic and outer : polypropylene) of",
  "Inner PE Outer CARTON": "in plastic bags contained in cartons of",
  "Inner PE Outer TRAY": "in plastic bags contained in tray of",
  "Inner PP Outer PP Bag": "in polypropylene bags contained in polypropylene of",
  "Inner PP Outer GUNNY": "in double bags (inner : plastic and outer : gunny) of",
}

const pairData = {
  'WhiteGlutinousRice10': {
    'TH': 'ข้าวเหนียวขาว10%',
    'EN': 'White  Glutinous Rice 10%',
  },
  'WhiteGlutinousRice25': {
    'TH': 'ข้าวเหนียวขาว25%',
    'EN': 'White  Glutinous Rice 25%',
  },
  'WhiteGlutinousBrokenRiceA1': {
    'TH': 'ข้าวเหนียวขาวหักเอวัน',
    'EN': 'White Glutinous Broken Rice A1',
  },
  'CargoRice5': {
    'TH': 'ข้าวกล้อง5%',
    'EN': 'Cargo Rice 5%',
  },
  'CargoRice10': {
    'TH': 'ข้าวกล้อง10%',
    'EN': 'Cargo Rice 10%',
  },
  'CargoRice15': {
    'TH': 'ข้าวกล้อง15%',
    'EN': 'Cargo Rice 15%',
  },
  'CargoRice100GradeA': {
    'TH': 'ข้าวกล้อง100%ชั้น1',
    'EN': 'Cargo Rice 100% Grade A',
  },
  'CargoRice100GradeB': {
    'TH': 'ข้าวกล้อง100%ชั้น2',
    'EN': 'Cargo Rice 100% Grade B',
  },
  'CargoRice100GradeC': {
    'TH': 'ข้าวกล้อง100%ชั้น3',
    'EN': 'Cargo Rice 100% Grade C',
  },
  'ThaiFragrantCargoRice5': {
    'TH': ['ข้าวกล้องหอมไทย5%', 'ข้าวกล้องหอมมะลิไทย5%'],
    'EN': 'Thai Fragrant Cargo Rice 5%',
  },
  'ThaiFragrantCargoRice10': {
    'TH': ['ข้าวกล้องหอมไทย10%', 'ข้าวกล้องหอมมะลิไทย10%'],
    'EN': 'Thai Fragrant Cargo Rice 10%',
  },
  'ThaiFragrantCargoRice15': {
    'TH': ['ข้าวกล้องหอมไทย15%', 'ข้าวกล้องหอมมะลิไทย15%'],
    'EN': 'Thai Fragrant Cargo Rice 15%',
  },
  'ThaiFragrantCargoRice100': {
    'TH': ['ข้าวกล้องหอมไทย100%', 'ข้าวกล้องหอมมะลิไทย100%'],
    'EN': 'Thai Fragrant Cargo Rice 100%',
  },
  'WhiteRice5': {
    'TH': 'ข้าวขาว5%',
    'EN': 'White Rice 5%',
  },
  'WhiteRice10': {
    'TH': 'ข้าวขาว10%',
    'EN': 'White Rice 10%',
  },
  'WhiteRice15': {
    'TH': 'ข้าวขาว15%',
    'EN': 'White Rice 15%',
  },
  'WhiteRice25': {
    'TH': 'ข้าวขาว25%',
    'EN': 'White Rice 25%',
  },
  'WhiteRice25Super': {
    'TH': 'ข้าวขาว5%เลิศ',
    'EN': 'White Rice 25% Super',
  },
  'WhiteRice35': {
    'TH': 'ข้าวขาว35%',
    'EN': 'White Rice 35%',
  },
  'WhiteRice45': {
    'TH': 'ข้าวขาว45%',
    'EN': 'White Rice 45%',
  },
  'WhiteRice100A': {
    'TH': 'ข้าวขาว100%ชั้น1',
    'EN': 'White Rice 100% A',
  },
  'WhiteRice100B': {
    'TH': 'ข้าวขาว100%ชั้น2',
    'EN': 'White Rice 100% B',
  },
  'WHITERICE100GRADEB': {
    'TH': 'ข้าวขาว100%ชั้น2',
    'EN': 'White Rice 100% B',
  },
  'WhiteRice100C': {
    'TH': 'ข้าวขาว100%ชั้น3',
    'EN': 'White Rice 100% C',
  },
  'WhiteBrokenRiceA1Super': {
    'TH': 'ข้าวขาวหักเอวันเลิศ',
    'EN': 'White Broken Rice A1 Super',
  },
  'WhiteBrokenRiceA1ExtraSuper': {
    'TH': 'ข้าวขาวหักเอวันเลิศพิเศษ',
    'EN': 'White Broken Rice A1 Extra Super',
  },
  'WhiteGlutinousRiceAsPerSample': {
    'TH': 'ข้าวเหนียวขาวตามตัวอย่าง',
    'EN': 'White  Glutinous Rice (As Per Sample)',
  },
  'WhiteGlutinousBrokenRiceC1AsPerSample': {
    'TH': 'ข้าวเหนียวขาวหักซีวันตามตัวอย่าง',
    'EN': 'White Glutinous Broken Rice C1 (As Per Sample)',
  },
  'WhiteGlutinousBrokenRiceAsPerSample': {
    'TH': 'ข้าวเหนียวขาวหักตามตัวอย่าง',
    'EN': 'White Glutinous Broken Rice (As Per Sample)',
  },
  'BlackGlutinousRiceAsPerSample': {
    'TH': 'ข้าวเหนียวดำตามตัวอย่าง',
    'EN': 'Black Glutinous Rice (As Per Sample)',
  },
  'CargoRiceAsPerSample': {
    'TH': 'ข้าวกล้องตามตัวอย่าง',
    'EN': 'Cargo Rice ( As Per Sample)',
  },
  'ShortGrainCargoRiceAsPerSample': {
    'TH': 'ข้าวกล้องเมล็ดสั้นตามตัวอย่าง',
    'EN': 'Short Grain Cargo Rice (As Per Sample)',
  },
  'JaponicaShortGrainCargoRiceAsPerSample': {
    'TH': 'ข้าวกล้องเมล็ดสั้นพันธุ์ญี่ปุ่นตามตัวอย่าง',
    'EN': 'Japonica Short Grain White Rice (As Per Sample)',
  },
  'GlutinousCargoRiceAsPerSample': {
    'TH': 'ข้าวกล้องเหนียวตามตัวอย่าง',
    'EN': 'Glutinous Cargo Rice (As Per Sample)',
  },
  'RedCargoRiceAsPerSample': {
    'TH': 'ข้าวกล้องแดงตามตัวอย่าง',
    'EN': 'Red Cargo Rice (As Per Sample)',
  },
  'GerminateRedCargoRiceAsPerSample': {
    'TH': 'ข้าวกล้องแดงงอกตามตัวอย่าง',
    'EN': 'Germinate Red Cargo Rice (As Per Sample)',
  },
  'GerminateCargoRiceAsPerSample': {
    'TH': 'ข้าวกล้องงอกตามตัวอย่าง',
    'EN': 'Germinate Cargo Rice (As Per Sample)',
  },
  'SpecialMixedGerminateCargoRiceAsPerSample': {
    'TH': 'ข้าวกล้องงอกผสมพิเศษตามตัวอย่าง',
    'EN': 'Special Mixed Germinate Cargo Rice (As Per Sample)',
  },
  'GerminateBlackCargoRiceAsPerSample': {
    'TH': 'ข้าวกล้องดำงอกตามตัวอย่าง',
    'EN': 'Germinate Black Cargo Rice (As Per Sample)',
  },
  'BasmatiCargoRiceAsPerSample': {
    'TH': 'ข้าวกล้องบาสมาติตามตัวอย่าง',
    'EN': 'Basmati Cargo Rice (As Per Sample)',
  },
  'SpecialMixedCargoRiceAsPerSample': {
    'TH': 'ข้าวกล้องผสมพิเศษตามตัวอย่าง',
    'EN': 'Special Mixed Cargo Rice (As Per Sample)',
  },
  'SpecialMixedCargoRiceAsPerSample': {
    'TH': 'ข้าวกล้องผสมพิเศษตามตัวอย่าง',
    'EN': 'Special Mixed Cargo Rice (As Per Sample)',
  },
  'ThaiFragrantCargoRiceAsPerSample': {
    'TH': 'ข้าวกล้องหอมไทยตามตัวอย่าง',
    'EN': 'Thai Fragrant Cargo Rice (As Per Sample)',
  },
  'CargoBrokenRiceAsPerSample': {
    'TH': 'ข้าวกล้องหักตามตัวอย่าง',
    'EN': 'Cargo Broken Rice (As Per Sample)',
  },
  'WhiteRice5AsPerSample': {
    'TH': 'ข้าวขาว5%ตามตัวอย่าง',
    'EN': 'White Rice 5% (As Per Sample)',
  },
  'WhiteRice10AsPerSample': {
    'TH': 'ข้าวขาว10%ตามตัวอย่าง',
    'EN': 'White Rice 10% (As Per Sample)',
  },
  'WhiteRice15AsPerSample': {
    'TH': 'ข้าวขาว15%ตามตัวอย่าง',
    'EN': 'White Rice 15% (As Per Sample)',
  },
  'WhiteRice25AsPerSample': {
    'TH': 'ข้าวขาว25%ตามตัวอย่าง',
    'EN': 'White Rice 25% (As Per Sample)',
  },
  'WhiteRice100AsPerSample': {
    'TH': 'ข้าวขาว100%ตามตัวอย่าง',
    'EN': 'White Rice 100% (As Per Sample)',
  },
  'WhiteRiceAsPerSample': {
    'TH': 'ข้าวขาวตามตัวอย่าง',
    'EN': 'White Rice (As Per Sample)',
  },
  'WhiteRiceEnrichedVitaminAsPerSample': {
    'TH': 'ข้าวขาวเคลือบวิตามินตามตัวอย่าง',
    'EN': 'White Rice Enriched Vitamin (As Per Sample)',
  },
  'ShortGrainWhiteRiceAsPerSample': {
    'TH': 'ข้าวขาวเมล็ดสั้นตามตัวอย่าง',
    'EN': 'Short Grain White Rice (As Per Sample)',
  },
  'JaponicaShortGrainWhiteRiceAsPerSample': {
    'TH': 'ข้าวขาวเมล็ดสั้นพันธุ์ญี่ปุ่นตามตัวอย่าง',
    'EN': 'Japonica Short Grain White Rice (As Per Sample)',
  },
  'BasmatiWhiteRiceAsPerSample': {
    'TH': 'ข้าวขาวบาสมาติตามตัวอย่าง',
    'EN': 'Basmati White Rice (As Per Sample)',
  },
  'ThaiFragrantWhiteRiceAsPerSample': {
    'TH': 'ข้าวขาวหอมไทยตามตัวอย่าง',
    'EN': 'Thai Fragrant White Rice (As Per Sample)',
  },
  'WhiteBrokenRiceC1AsPerSample': {
    'TH': 'ข้าวขาวหักซีวันตามตัวอย่าง',
    'EN': 'White Broken Rice C1 (As Per Sample)',
  },
  'WhiteBrokenRiceAsPerSample': {
    'TH': 'ข้าวขาวหักตามตัวอย่าง',
    'EN': 'White Broken Rice (As Per Sample)',
  },
  'WhiteBrokenRiceEnrichedVitaminAsPerSample': {
    'TH': 'ข้าวขาวหักเคลือบวิตามินตามตัวอย่าง',
    'EN': 'White Broken Rice Enriched Vitamin (As Per Sample)',
  },
  'ParboiledRiceAsPerSample': {
    'TH': 'ข้าวนึ่งตามตัวอย่าง',
    'EN': 'Parboiled Rice (As Per Sample)',
  },
  'CargoParboiledRiceAsPerSample': {
    'TH': 'ข้าวนึ่งกล้องตามตัวอย่าง',
    'EN': 'Cargo Parboiled Rice (As Per Sample)',
  },
  'ParboiledBrokenRiceAsPerSample': {
    'TH': 'ข้าวนึ่งหักตามตัวอย่าง',
    'EN': 'Parboiled Broken Rice (As Per Sample)',
  },
  'SpecialMixedRiceAsPerSample': {
    'TH': 'ข้าวผสมพิเศษตามตัวอย่าง',
    'EN': 'Special Mixed Rice (As Per Sample)',
  },
  'ParboiledRice5': {
    'TH': 'ข้าวนึ่ง5%',
    'EN': 'Parboiled Rice 5%',
  },
  'ParboiledRice5Sorted': {
    'TH': 'ข้าวนึ่ง5%คัด',
    'EN': 'Parboiled Rice 5% Sorted',
  },
  'ParboiledRice10': {
    'TH': 'ข้าวนึ่ง10%',
    'EN': 'Parboiled Rice 10%',
  },
  'ParboiledRice10Sorted': {
    'TH': 'ข้าวนึ่ง10%คัด',
    'EN': 'Parboiled Rice 10% Sorted',
  },
  'ParboiledRice15': {
    'TH': 'ข้าวนึ่ง15%',
    'EN': 'Parboiled Rice 15%',
  },
  'ParboiledRice25': {
    'TH': 'ข้าวนึ่ง25%',
    'EN': 'Parboiled Rice 25%',
  },
  'ParboiledRice100': {
    'TH': 'ข้าวนึ่ง100%',
    'EN': 'Parboiled Rice 100%',
  },
  'ParboiledRice100Sorted': {
    'TH': 'ข้าวนึ่ง100%คัด',
    'EN': 'Parboiled Rice 100% Sorted',
  },
  'ParboiledBrokenRiceA1': {
    'TH': 'ข้าวนึ่งหักเอวัน',
    'EN': 'Parboiled Broken Rice A1',
  },
  'ThaiFragrantWhiteRice5': {
    'TH': ['ข้าวขาวหอมไทย5%', 'ข้าวขาวหอมมะลิไทย5%', 'ข้าวเจ้าขาวหอมมะลิไทย5%', 'ข้าวเจ้าข้าวหอมไทย5%'],
    'EN': 'Thai Fragrant White Rice 5%',
  },
  'ThaiFragrantWhiteRice10': {
    'TH': ['ข้าวขาวหอมไทย10%', 'ข้าวขาวหอมมะลิไทย10%', 'ข้าวเจ้าขาวหอมมะลิไทย10%', 'ข้าวเจ้าข้าวหอมไทย10%'],
    'EN': 'Thai Fragrant White Rice 10%',
  },
  'ThaiFragrantWhiteRice15': {
    'TH': ['ข้าวขาวหอมไทย15%', 'ข้าวขาวหอมมะลิไทย15%', 'ข้าวเจ้าขาวหอมมะลิไทย15%', 'ข้าวเจ้าข้าวหอมไทย15%'],
    'EN': 'Thai Fragrant White Rice 15%',
  },
  'ThaiFragrantWhiteRice100': {
    'TH': ['ข้าวขาวหอมไทย100%', 'ข้าวขาวหอมมะลิไทย100%', 'ข้าวเจ้าขาวหอมมะลิไทย100%', 'ข้าวเจ้าข้าวหอมไทย100%'],
    'EN': 'Thai Fragrant White Rice 100%',
  },
  'ThaiFragrantWhiteBrokenRiceA1Super': {
    'TH': 'ข้าวขาวหักเอวันเลิศข้าวหอมไทย',
    'EN': 'Thai Fragrant White Broken Rice A1 Super',
  },
  'ThaiFragrantWhiteBrokenRiceA1ExtraSuper': {
    'TH': ['ข้าวขาวหักเอวันเลิศพิเศษข้าวหอมไทย', 'ปลายข้าวข้าวขาวหอมมะลิไทยเอวันเลิศพิเศษ', 'ปลายข้าวข้าวเจ้าขาวหอมไทยเอวันเลิศพิเศษ', 'ปลายข้าวข้าวขาวหอมไทยเอวันเลิศพิเศษ'],
    'EN': 'Thai Fragrant White Broken Rice A1 Extra Super',
  },
  'RedGlutinousCargoRiceAsPerSample': {
    'TH': ['ข้าวกล้องเหนียวสีแดงตามตัวอย่าง'],
    'EN': 'Red Glutinous Cargo Rice (As Per Sample)',
  },
  'RedGlutinousCargoRicePrimeQuality': {
    'TH': 'ข้าวกล้องเหนียวสีแดงชั้นดีเลิศ',
    'EN': 'Red Glutinous Cargo Rice Prime Quality',
  },
  'RedGlutinousCargoRiceSuperbQuality': {
    'TH': 'ข้าวกล้องเหนียวสีแดงชั้นดีพิเศษ',
    'EN': 'Red Glutinous Cargo Rice Superb Quality',
  },
  'BlackGlutinousCargoRiceAsPerSample': {
    'TH': 'ข้าวกล้องเหนียวสีดำสีม่วงดำและสีม่วงตามตัวอย่าง',
    'EN': 'Black Glutinous Cargo Rice (As Per Sample)',
  },
  'BlackGlutinousCargoRiceStandardQuality': {
    'TH': 'ข้าวกล้องเหนียวสีดำสีม่วงดำและสีม่วงชั้นมาตรฐาน',
    'EN': 'Black Glutinous Cargo Rice Standard Quality',
  },
  'BlackGlutinousCargoRiceBestQuality': {
    'TH': 'ข้าวกล้องเหนียวสีดำสีม่วงดำและสีม่วงชั้นดี',
    'EN': 'Black Glutinous Cargo Rice Best Quality',
  },
  'RedCargoRicePrimeQuality': {
    'TH': 'ข้าวกล้องเจ้าสีแดงชั้นดีเลิศ',
    'EN': 'Red Cargo Rice Prime Quality',
  },
  'RedCargoRiceSuperbQuality': {
    'TH': 'ข้าวกล้องเจ้าสีแดงชั้นดีพิเศษ',
    'EN': 'Red Cargo Rice Superb Quality',
  },
  'BlackCargoRiceAsPerSample': {
    'TH': 'ข้าวกล้องเจ้าสีดำสีม่วงดำและสีม่วงตามตัวอย่าง',
    'EN': 'Black Cargo Rice (As Per Sample)',
  },
  'BlackCargoRicePrimeQuality': {
    'TH': 'ข้าวกล้องเจ้าสีดำสีม่วงดำและสีม่วงชั้นดีเลิศ',
    'EN': 'Black Cargo Rice Prime Quality',
  },
  'BlackCargoRiceSuperbQuality': {
    'TH': 'ข้าวกล้องเจ้าสีดำสีม่วงดำและสีม่วงชั้นดีพิเศษ',
    'EN': 'Black Cargo Rice Superb Quality',
  },
  '1006.30.70-001': {
    'TH': 'THAI FRAGRANT WHITE RICE 100%',
    'EN': 'THAI FRAGRANT WHITE RICE 100%',
  },
  'SpecialMixedColourCargoRiceAsPerSample':{
    'TH': 'ข้าวกล้องเจ้าสีแดงและสีดำตามตัวอย่าง',
    'EN': 'Special Mixed Colour Cargo Rice (As Per Sample)',
  }
}

module.exports.convertRiceType = (riceParaGraph, pairData) => {
  let resultSearchArr = []

  Object.keys(pairData).map((title) => {
    if (!Array.isArray(pairData[title]['riceTypeName'])) {
      if (riceParaGraph.ProductDescription.replace(/\s+|\(+|\)+/g, '').indexOf(pairData[title]['riceTypeName']) !== -1) {
        resultSearchArr.push(pairData[title]['riceTypeName'])
      }
    } else {
      pairData[title]['riceTypeName'].map((pairDataInside) => {
        if (riceParaGraph.ProductDescription.replace(/\s+|\(+|\)+/g, '').indexOf(pairDataInside) !== -1) {
          resultSearchArr.push(pairDataInside)
        }
      })
    }
  })
  if (resultSearchArr.length > 1) {
    if (resultSearchArr[0].length > resultSearchArr[1].length) {
      return resultSearchArr[0]
    } else {
      return resultSearchArr[1]
    }
  } else if (resultSearchArr.length === 1) {
    return resultSearchArr[0]
  } else {
    return 'blank'
  }
}
module.exports.convertRiceTypeTHToEN = (riceParah, pairData) => {
  let resultSearchArr = []
  if(riceParah == 'ข้าวกล้องสีผสมพิเศษ (ตามตัวอย่าง) (ข้าวอินทรีย์)'){
    console.log('found')
  }
  let a = Object.values(pairData).filter((e) => {
    return e['riceTypeName'] === riceParah
  })
  if (a.length > 0) {
    return a[0]['riceTypeID']
  } else {
    return null
  }
}

module.exports.convertRiceTypeEN = (riceParaGraph, pairData) => {

  //   function CallbackComponent(props){
  //     // eslint-disable-next-line react/react-in-jsx-scope
  //     return  <td><input type="number" id="riceTypeID" onChange={(e)=>{this.HandleChangeDescription(e,idx)}}></input></td>
  //   }
  // console.log(riceParaGraph)
  let resultSearchArr = []
  Object.keys(pairData).map((title) => {
    if (!Array.isArray(pairData[title]['riceTypeName'])) {
      if (riceParaGraph.ProductDescription.replace(/\s+|\(+|\)+/g, '').indexOf(pairData[title]['riceTypeName']) !== -1) {
        resultSearchArr.push(title)
      }
    } else {
      pairData[title]['riceTypeName'].map((pairDataInside) => {
        if (riceParaGraph.ProductDescription.replace(/\s+|\(+|\)+/g, '').indexOf(pairDataInside) !== -1) {
          resultSearchArr.push(title)
        }
      })
    }
  })
  // console.log(resultSearchArr)
  if (resultSearchArr.length > 1) {
    if (resultSearchArr[0].length > resultSearchArr[1].length) {
      return resultSearchArr[0]
    } else {
      return resultSearchArr[1]
    }
  } else if (resultSearchArr.length === 1) {
    return resultSearchArr[0]
  } else {
    return 'blank'
  }
}
module.exports.convertRiceTypeENToTH = (riceParaGraph, pairData, mode = 'default') => {
  if (mode == 'default') {
    if (riceParaGraph && riceParaGraph != 'blank') {
      // console.log(riceParaGraph)
      let a = Object.values(pairData).filter((e) => {
        return e['riceTypeID'] === riceParaGraph
      })
      // console.log(a,a.length)
      if (a.length == 1) {
        return a[0]['riceTypeName']
      }
      else if (a.length > 1) {
        return a
      }
      else {
        return 'error'
      }
    }
  } else if (mode == 'standalone') {
    if (riceParaGraph && riceParaGraph != 'blank') {
      // console.log(Object.values(pairData))
      let a = Object.values(pairData).filter((e) => {
        return e['riceTypeID'] === riceParaGraph
      })
      if (a.length > 0) {
        return a[0]['riceTypeName']
      }
      else {
        return null
      }
    }

  }
}
module.exports.convertRiceTypeENToENFull = (riceParaGraph) => {
  // NeedToEdit 
  if (riceParaGraph) {
    // console.log(riceParaGraph)
    if (pairData[riceParaGraph]?.['EN']) {
      let temp = pairData[riceParaGraph]?.['EN'].toUpperCase()
      temp = temp.replace(/  /gi, ' ')
      let strSplit = temp.split(' ')
      temp = ''
      strSplit.map((e, idx) => {
        // console.log(temp , idx < strSplit.length-1 , idx ,strSplit.length-1 )
        if (parseInt(idx) < parseInt(parseInt(strSplit.length) - 1)) {
          temp += `${e}  `
          // console.log(temp)
        } else {
          temp += `${e}.`
        }
      })
      return `${temp}`
    } else {
      let temp = riceParaGraph.toUpperCase()
      // let strSplit = temp.split(' ')
      // temp = ''
      // strSplit.map((e,idx)=>{
      //   if(parseInt(idx) < parseInt(parseInt(strSplit.length)-1)){
      //     temp += `${e}  `
      //   }else{
      //     temp += `${e}.`
      //   }
      // })
      return `${temp}`
    }
  } else {
    return riceParaGraph
  }
}
module.exports.getQuantity = (state) => {
  if (state) {
    try {
      let quantity = state['bagQuantity'].toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')

      if (state['PackingType'] == 'Inner PE Outer CARTON') {
        quantity = `${quantity}  cartons`
      }
      else if (state['PackingType'] == 'Inner PE Outer TRAY') {
        quantity = `${quantity}  trays`
      }
      else if (state['PackingType'] == 'Inner PE Outer TRAY') {
        quantity = `${quantity}  kgs.nett`
      }
      else if (state['PackingType'] == 'In Bulk') {
        quantity = `-  bags`
      }
      else {
        quantity = `${quantity}  bags`
      }
      return this.addCommaInNumber(quantity)
    } catch (error) {
      let quantity = state['Quantity'].toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
      quantity = `${quantity * 1000 / state['netWeight']}  bags`
      return this.addCommaInNumber(quantity)
    }
  }
}
module.exports.getDescription = (state) => {
  if (state) {
    // let description = this.convertRiceTypeENToENFull(state['riceTypeID']).toUpperCase()
    // if(description[description.length-2] == '%'){

    //   return `${description.slice(0,description.length-1)}.`
    // }else{
    //   return `${description}.`
    // }
    let traffic = state['wtf']
    let a = {
      "0": { "trafficType": "1006.30.30-003", "des": "", "riceEN": "WhiteGlutinousRice10" }, "1": { "trafficType": "1006.20.90-607", "des": "", "riceEN": "BlackCargoRiceSuperbQuality" }, "2": { "trafficType": "1006.30.40-001", "des": "", "riceEN": "ThaiFragrantWhiteRice100" }, "3": { "trafficType": "1006.20.90-613", "des": "", "riceEN": "RedCargoRiceSuperbQuality" }, "4": { "trafficType": "1006.30.99-001", "des": "", "riceEN": "ThaiFragrantWhiteRice100" }, "5": { "trafficType": "1006.20.90-619", "des": "", "riceEN": "BlackGlutinousCargoRiceStandardQuality" }, "6": { "trafficType": "1006.20.90-608", "des": "", "riceEN": "BlackCargoRicePrimeQuality" }, "7": { "trafficType": "1006.20.90-614", "des": "", "riceEN": "RedCargoRicePrimeQuality" }, "8": { "trafficType": "1006.20.90-501", "des": "" }, "9": { "trafficType": "1006.20.90-001", "des": "", "riceEN": "ThaiFragrantCargoRice100" }, "10": { "trafficType": "1006.20.90-606", "des": "", "riceEN": "BlackCargoRicePrimeQuality" }, "11": { "trafficType": "1006.20.90-612", "des": "", "riceEN": "RedCargoRicePrimeQuality" }, "12": { "trafficType": "1006.30.91-002", "des": "", "riceEN": "ParboiledRice100" }, "13": { "trafficType": "1006.30.99-018", "des": "", "riceEN": "WhiteRice25" }, "14": { "trafficType": "1006.30.99-012", "des": "", "riceEN": "WhiteRice5" }, "15": { "trafficType": "1006.30.30-006", "des": "" }, "16": { "trafficType": "1006.30.99-007", "des": "" }, "17": { "trafficType": "1006.40.90-006", "des": "", "riceEN": "WhiteBrokenRiceA1Super" }, "18": { "trafficType": "1006.40.90-019", "des": "", "riceEN": "WhiteGlutinousBrokenRiceA1" }, "19": { "trafficType": "1006.40.90-602", "des": "", "riceEN": "WhiteGlutinousBrokenRiceAsPerSample" }, "20": { "trafficType": "1006.30.91-001", "des": "", "riceEN": "ParboiledRice100Sorted" }, "21": { "trafficType": "1006.30.91-600", "des": "", "riceEN": "ParboiledRiceAsPerSample" }, "22": { "trafficType": "1006.30.99-013", "des": "", "riceEN": "WhiteRice10" }, "23": { "trafficType": "1006.30.91-003", "des": "", "riceEN": "ParboiledRice5Sorted" }, "24": { "trafficType": "1006.40.90-005", "des": "", "riceEN": "ThaiFragrantWhiteBrokenRiceA1Super" }, "25": { "trafficType": "1006.20.90-018", "des": "", "riceEN": "CargoRice100GradeB" }, "26": { "trafficType": "1006.20.90-616", "des": "" }, "27": { "trafficType": "1006.30.99-010", "des": "", "riceEN": "WhiteRice100B" }, "28": { "trafficType": "1006.30.99-601", "des": "", "riceEN": "WhiteRiceAsPerSample" }, "29": { "trafficType": "1006.40.90-012", "des": "", "riceEN": "ThaiFragrantWhiteBrokenRiceA1Super" }, "30": { "trafficType": "1006.20.90-604", "des": "", "riceEN": "SpecialMixedCargoRiceAsPerSample" }, "31": { "trafficType": "1006.20.90-504", "des": "", "riceEN": "CargoRiceAsPerSample" }, "32": { "trafficType": "1006.20.90-615", "des": "", "riceEN": "RedCargoRiceSuperbQuality" }, "33": { "trafficType": "1006.40.90-010", "des": "", "riceEN": "ThaiFragrantWhiteBrokenRiceA1Super" }, "34": { "trafficType": "1006.30.99-003", "des": "", "riceEN": "ThaiFragrantWhiteRice5" }, "35": { "trafficType": "1006.30.99-600", "des": "", "riceEN": "ThaiFragrantWhiteRiceAsPerSample" }, "36": { "trafficType": "1006.20.90-506", "des": "", "riceEN": "ThaiFragrantCargoRice100" }, "37": { "trafficType": "1006.20.90-633", "des": "" }, "38": { "trafficType": "1006.30.99-014", "des": "", "riceEN": "WhiteRice15" }, "39": { "trafficType": "1006.20.90-600", "des": "" }, "40": { "trafficType": "1006.20.90-601", "des": "", "riceEN": "ThaiFragrantCargoRiceAsPerSample" }, "41": { "trafficType": "1006.30.99-603", "des": "", "riceEN": "SpecialMixedRiceAsPerSample" }, "42": { "trafficType": "1006.20.90-630", "des": "" }, "43": { "trafficType": "1006.20.90-618", "des": "", "riceEN": "BlackGlutinousCargoRiceBestQuality" }, "44": { "trafficType": "1006.40.90-018", "des": "", "riceEN": "ParboiledBrokenRiceA1" }, "45": { "trafficType": "1006.40.90-600", "des": "", "riceEN": "WhiteBrokenRiceC1AsPerSample" }, "46": { "trafficType": "1006.30.30-004", "des": "", "riceEN": "WhiteGlutinousRice10" }, "47": { "trafficType": "1006.40.90-001", "des": "", "riceEN": "CargoBrokenRiceAsPerSample" }, "48": { "trafficType": "1006.20.90-632", "des": "" }, "49": { "trafficType": "1006.30.91-007", "des": "", "riceEN": "ParboiledRice15" }, "50": { "trafficType": "1006.30.91-004", "des": "", "riceEN": "ParboiledRice5" }, "51": { "trafficType": "1006.20.90-010", "des": "", "riceEN": "CargoRice5" }, "52": { "trafficType": "1006.30.99-009", "des": "", "riceEN": "WhiteRice100A" }, "53": { "trafficType": "1006.20.90-609", "des": "", "riceEN": "BlackCargoRiceSuperbQuality" }, "54": { "trafficType": "1006.30.99-015", "des": "" }, "55": { "trafficType": "1006.30.99-502", "des": "", "riceEN": "ThaiFragrantWhiteRice100" }, "56": { "trafficType": "1006.30.40-500", "des": "", "riceEN": "ThaiFragrantWhiteRice100" }, "57": { "trafficType": "1006.40.90-004", "des": "", "riceEN": "WhiteBrokenRiceA1ExtraSuper" }, "58": { "trafficType": "1006.30.99-602", "des": "", "riceEN": "WhiteRiceAsPerSample" }, "59": { "trafficType": "1006.20.90-610", "des": "", "riceEN": "BlackCargoRiceAsPerSample" }, "60": { "trafficType": "1006.20.90-622", "des": "" }, "61": { "trafficType": "1006.20.90-631", "des": "" }, "62": { "trafficType": "1006.20.90-605", "des": "", "riceEN": "ThaiFragrantCargoRiceAsPerSample" }, "63": { "trafficType": "1006.30.30-601", "des": "" }, "64": { "trafficType": "1006.30.99-023", "des": "", "riceEN": "WhiteRiceEnrichedVitaminAsPerSample" }, "65": { "trafficType": "1006.30.40-006", "des": "", "riceEN": "ThaiFragrantWhiteRice15" }, "66": { "trafficType": "1006.40.90-003", "des": "" }, "67": { "trafficType": "1006.30.99-022", "des": "", "riceEN": "WhiteRice45" }, "68": { "trafficType": "1006.30.99-011", "des": "", "riceEN": "WhiteRice100C" }, "69": { "trafficType": "1006.30.99-005", "des": "" }, "70": { "trafficType": "1006.20.90-011", "des": "", "riceEN": "CargoRice10" }, "71": { "trafficType": "1006.40.90-609", "des": "" }, "72": { "trafficType": "1006.20.90-012", "des": "" }, "73": { "trafficType": "1006.20.90-508", "des": "" }, "74": { "trafficType": "1006.20.90-611", "des": "" }, "75": { "trafficType": "1006.20.90-617", "des": "" },
      "76": {
        "trafficType": "1006.20.90-620", "des": "", "riceEN": "BlackGlutinousCargoRiceBestQuality",
      }
    }
    let output = traffic
    Object.values(a).map((data) => {
      if (data['trafficType'] == traffic) {
        output = data['riceEN']
      }
    })
    return output
  } else {
    return ''
  }
}
module.exports.getDestination = (state) => {
  if (state) {
    let destination = state['destinationCity']?.toLowerCase() || state['checkWeight']?.['destinationCity']?.toLowerCase() || ''
    destination = destination.charAt(0).toUpperCase() + destination.slice(1)
    // destination = destination.split(' ')
    // console.log(destination)
    // let temp = ''
    // destination.map((e)=>{
    //   if(`${e}`.toLowerCase() == 'fz'){
    //     temp += `FZ `
    //   }else{
    //     temp += `${e} `
    //   }
    // })
    // console.log(destination)
    return destination
  }
}
module.exports.getMask = (state) => {
  if (state['logo']) {
    let destination = state['logo'].toUpperCase()
    return destination
  } else {
    return 'xxxxxx'
  }
}
module.exports.getShippingBehalf = (state) => {
  if (state['surveyCompany']) {
    let behalf = state['surveyCompany']
    return behalf
  } else {
    return 'XXXXXXXXXX'
  }
}
module.exports.getLoadingDate = (state) => {
  if (state['shippingDate']) {
    // console.log(state['shippingDate'])
    let months = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December']
    let date = state['shippingDate']
    let year = date.slice(0, 4)
    let month = months[parseInt(date.slice(5, 7) - 1)]
    let days = parseInt(date.slice(8, 10))
    if (days && month && year) {
      return `${days}   ${month}  ${year}`
    } else {
      return state['shippingDate']
    }
  }
}
module.exports.getShippingPort = (state) => {
  if (state) {
    let shippingPort = state['surveyLocateName']
    return 'Bangkok'
  }
}
module.exports.getPlaceLoading = (state, godownArr) => {
  if (state['godown']) {
    let fullGodown = state['godown'].toUpperCase()

    if (fullGodown.indexOf('GODOWN') != -1) {
      return state['godown']
    } else {
      let godownLength = Object.values(godownArr).filter((o) => {
        if (o.surveyNameEN) {
          return o.surveyNameEN.trim() == fullGodown.trim()
        }
      })
      if (!godownLength[0]?.['surveyNameENFull']) {
        let PlaceLoading = state['godown'].toLowerCase().trim()
        PlaceLoading = PlaceLoading.replace(/  /gi, ' ')
        PlaceLoading = PlaceLoading.split(" ")
        let temp = ''
        PlaceLoading.map((e) => {

          if (e != 'of' && e.indexOf('(') == -1) {
            temp += `${(e.charAt(0).toUpperCase() + e.slice(1))}  `
          }
          else if (e.indexOf('(') != -1) {
            // console.log( e.charAt(1))
            temp += `${(e.charAt(0) + e.charAt(1).toUpperCase() + e.slice(2))}  `
          } else {
            temp += `${(e.charAt(0).toUpperCase() + e.slice(1))}  `
          }
        })
        let strSplit = temp.split('')
        temp = ''
        strSplit.map((e, idx) => {
          // console.log(e)
          if (strSplit[idx - 1] == '.') {
            temp += `${e.toUpperCase()}`
          } else {
            temp += `${e}`
          }
        })
        if (temp.indexOf('Herba  Bangkok') != -1) {
          return `${temp}S.L.  godown`
        }
        else if (temp.indexOf('Customs  Station') != -1) {
          return temp
        }
        else {
          return `${temp}godown`
        }
      } else {
        return godownLength[0]['surveyNameENFull']
      }
    }

  } else {
    return ''
  }
}

module.exports.getCarrayVessel = (state) => {
  if (state) {
    let vehicleKey = ''
    // console.log(state)
    Object.keys(state).map((key) => { if (key.indexOf('vehicleName') != -1) vehicleKey = key })

    let carryVessel = state[vehicleKey]
    // console.log(carryVessel)
    if (!carryVessel && state['checkWeight']) {
      Object.keys(state['checkWeight']).map((key) => { if (key.indexOf('vehicleName') != -1) vehicleKey = key })
      carryVessel = state['checkWeight'][vehicleKey]
    }

    if (carryVessel) {
      if (carryVessel.toLowerCase() == 'by  truck' || carryVessel.toLowerCase() == 'by truck') {
        let temp = `${carryVessel}`
        let strSplit = temp.split(' ')
        temp = ''
        strSplit.map((e, idx) => {
          if (parseInt(idx) < parseInt(parseInt(strSplit.length) - 1)) {
            temp += `${e}  `
          } else {
            temp += `${e}`
          }
        })
        return `${temp}`
      } else {
        let temp = `S.S. “${carryVessel}”`
        let strSplit = temp.split(' ')
        temp = ''
        strSplit.map((e, idx) => {
          if (parseInt(idx) < parseInt(parseInt(strSplit.length) - 1)) {
            temp += `${e}  `
          } else {
            temp += `${e}`
          }
        })

        return `${temp}`
      }
    } else {
      return ''
    }

  }
}
module.exports.getPacking = (state) => {
  // console.log(state['PackingType'])
  if (state['PackingType']) {
    let packing = pairOption[state['PackingType']]
    if (packing) {
      return packing
    }
    else {
      return 'Others'
    }
  } else {
    return 'Others'
  }
}
module.exports.getShipper = (state) => {
  if (state) {
    let shipper = state['companyID']
    // console.log(state['companyID'])
    return new Promise((resolve, reject) => {
      fetch('https://us-central1-riceinspection-16b06.cloudfunctions.net/middleWare', {
        method: 'post',
        headers: {
          'Accept': 'application/json, text/plain, */*',
          'Content-Type': 'application/json',
        }, body: JSON.stringify({
          'action': 'viewCompany',
          'data': {
            'companyID': shipper,
          },
        }),
      }).then(res => res.json())
        .then((data) => {
          // console.log(Object.values(data)[0])
          let PlaceLoading = Object.values(data)[0]['companyNameEN'].toLowerCase()
          PlaceLoading = PlaceLoading.split(" ")
          let temp = ''
          PlaceLoading.map((e) => { temp += `${(e.charAt(0).toUpperCase() + e.slice(1))} ` })

          resolve(temp)
        }).catch(err => reject(err))
    })
  }
}
module.exports.getExportLicense = (state) => {
  if (state['licenseID']) {
    return state['licenseID'].slice(6, state['licenseID'].lenght)
  }
}

module.exports.getEachGrossWeight = (state) => {
  let grossWeightKey = null
  Object.keys(state).map((title) => {
    if (title.indexOf('grossWeight') != - 1 && !isNaN(state[title])) {
      grossWeightKey = title
    }
  })
  if (state[grossWeightKey]) {
    let quantity = (state[grossWeightKey] * 100000)
    quantity = (quantity / 100000)
    if (quantity * 100 - parseInt(quantity * 100) > 0) {
      if (!isNaN(quantity)) {
        return quantity
      } else {
        return '-'
      }
    } else {
      if (!isNaN(quantity)) {
        let fixed = 2
        fixed = this.getFixedPoint(state['netWeight'])
        return quantity.toFixed(fixed)
      } else {
        return '-'
      }
    }

  }
}

module.exports.getFixedPoint = (data) => {
  if (data * 100 - parseInt(data * 100) > 0) {
    let fixedLength = 2
    fixedLength = parseInt(`${data}`.length) - parseInt(`${data}`.indexOf('.')) - 1
    return fixedLength
  } else {
    return 2
  }
}
module.exports.getEachNetWeight = (state) => {
  if (state['netWeight']) {
    // let quantity = state['quantity'].toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
    let quantity = (state['netWeight'] * 100000)
    // let quantity = 12.112 *100000
    quantity = (quantity / 100000)
    if (quantity * 100 - parseInt(quantity * 100) > 0) {
      if (!isNaN(quantity)) {
        return quantity
      } else {
        return '-'
      }
    } else {
      if (!isNaN(quantity)) {
        let fixed = 2
        let grossWeightKey = null
        Object.keys(state).map((title) => {
          if (title.indexOf('grossWeight') != - 1 && !isNaN(state[title])) {
            grossWeightKey = title
          }
        })
        fixed = this.getFixedPoint(state[grossWeightKey])
        return quantity.toFixed(fixed)
      } else {
        return '-'
      }
    }
  }
}

module.exports.getGrossWeight = (state) => {
  let grossWeightKey = null
  Object.keys(state).map((title) => {
    if (title.indexOf('grossWeight') != - 1 && !isNaN(state[title])) {
      grossWeightKey = title
    }
  })

  if (state[grossWeightKey]) {
    // let quantity = state['quantity'].toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
    // console.log((state['bagQuantity'] || state['Quantity']) * state[grossWeightKey] * 100000)
    let quantity = (state['bagQuantity'] || state['Quantity']) * (state[grossWeightKey] * 100000)
    quantity = (quantity / 100000).toFixed(3)
    if (!isNaN(quantity)) {
      return quantity
    } else {
      return '-'
    }
  } else {
    return '-'
  }
}
module.exports.getNetWeight = (state) => {
  if (state['netWeight']) {
    // let quantity = state['quantity'].toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
    // quantity = quantity*1000/state['netWeight']
    let quantity = (state['bagQuantity'] || state['Quantity']) * (state['netWeight'] * 100000)
    quantity = (quantity / 100000).toFixed(3)
    if (!isNaN(quantity)) {
      return quantity
    } else {
      return '-'
    }
  }
}
module.exports.getTareWeight = (state) => {
  let grossWeightKey = null
  Object.keys(state).map((title) => {
    if (title.indexOf('grossWeight') != - 1 && !isNaN(state[title])) {
      grossWeightKey = title
    }
  })

  if (state['netWeight']) {
    // let quantity = state['quantity'].toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
    // quantity = quantity*1000/state['netWeight']
    // console.log(state)
    let quantity = state['bagQuantity'] || state['Quantity']
    let netWeight = Number(state['netWeight']) * (Number(quantity) * 100000)
    let grossWeight = Number(state[grossWeightKey]) * (Number(quantity) * 100000)
    netWeight = (netWeight / 100000)
    grossWeight = (grossWeight / 100000)
    // console.log(quantity)
    if (!isNaN((grossWeight - netWeight).toFixed(3))) {
      return (grossWeight - netWeight).toFixed(3)
    } else {
      return '-'
    }
  }
}
module.exports.addCommaInNumber = (Num) => {
  var regex = /^[0-9]+$/
  if (!isNaN(Num)) {
    var parts = Num.toString().split('.');
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return parts.join('.');
  } else {
    return Num
  }
}
module.exports.getCompanyFromDescription = (companyDescription) => {
  if (companyDescription) {
    let indexWord = companyDescription.indexOf('จำกัด')
    let topicK = null
    // console.log(companyDescription)
    if (indexWord != -1) {
      topicK = companyDescription.slice(0, (parseInt(indexWord) + 5))
      let indexWorded = companyDescription.indexOf('ห้างหุ้นส่วน')
      // console.log(topicK)
      if (indexWorded != -1) {
        topicK = companyDescription.slice(0, parseInt(companyDescription.search(/\d+[/]?\d+?/g)))
        topicK = topicK.replace('เลขที่', '')
      }
    } else {
      if (companyDescription.indexOf('กรมการค้าต่างประเทศ') != -1) {
        topicK = null
      } else {
        topicK = null
      }
    }
    topicK = topicK?.replace(/\s/g, '')
    return topicK
  } else {
    return null
  }
}

module.exports.updateState = (RequestComplete, RequestJobComplete, viewAllOfficer, viewAllCompany) => {
  let arr = []
  // console.log(!RequestJobComplete['message'])

  Object.keys(RequestComplete).map((title) => {
    if (title !== 'countJobID') {
      if (typeof RequestComplete[title] == 'object' && !RequestJobComplete['message']) {
        if (!RequestComplete['message']) {
          // console.log(!RequestComplete['message'])
          let temp = Object.values(RequestJobComplete).filter((e) => { return e['requestID'] == RequestComplete[title]['requestID'] })
          if (temp.length != 0) {
            RequestComplete[title]['jobID'] = temp[0]['jobID']
            if (temp[0]['chainID'] == 'chain') {
              RequestComplete[title]['chainID'] = 'ต่อ'
            }
            if (temp[0]['chainID'] == 'extraround') {
              RequestComplete[title]['chainID'] = 'นอกรอบ'
            }
            if (temp[0]['chainID'] == 'sampling') {
              RequestComplete[title]['chainID'] = 'เก็บตัวอย่าง'
            }
            if (temp[0]['chainID'] == 'controlloading') {
              RequestComplete[title]['chainID'] = 'คุมขนถ่าย'
            }
            if (temp[0]['chainID'] == 'cancleloading') {
              RequestComplete[title]['chainID'] = 'งดบรรทุก'
            }
            if (temp[0]['chainID'] == 'extrajob') {
              RequestComplete[title]['chainID'] = 'งานพิเศษ'
            }
            if (temp[0]['chainID'] == 'blank') {
              RequestComplete[title]['chainID'] = 'blank'
            }

            RequestComplete[title]['officerID'] = temp[0]['officerID']
            RequestComplete[title]['officerID2'] = temp[0]['officerID2']
            arr = arr.concat([RequestComplete[title]])
          } else {
            RequestComplete[title]['officerID'] = ''
            RequestComplete[title]['officerID2'] = ''
            arr = arr.concat([RequestComplete[title]])
          }
        }
      }
    }
  })
  // console.log(arr)
  Object.values(viewAllOfficer).map((Checker) => {
    let id = Checker['ID']
    arr.forEach((data) => {
      if (data['officerID'] == id) {
        data['officerID'] = `${parseInt(Checker['userName']) + 1}. ${Checker['fName']}`
      }
      if (data['officerID2'] == id) {
        data['officerID2'] = `${parseInt(Checker['userName']) + 1}. ${Checker['fName']} `
      }
      if (data['officerID2'] == '') {
        data['officerID2'] = `-`
      }
    })
  })
  Object.values(viewAllCompany).map((Company) => {
    let id = Company['companyID']
    arr.forEach((data) => {
      // console.log(data['companyID'])
      if (data['companyID'] == id) {
        data['companyID'] = `${Company['companyNameEN']}`
      }
    })
  })
  let surveyName = []
  let riceDescriptionArr = {}
  arr.sort((a, b) => (parseInt(a['jobID']) > parseInt(b['jobID'])) ? 1 : ((parseInt(b['jobID']) > parseInt(a['jobID'])) ? -1 : 0))
  arr.forEach((data, idx) => {
    // console.log(data)
    if (data['chainID'] !== 'none') {
      let temp = arr.filter((e) => { return e['requestID'] == data['chainID'] })
      if (temp.length != 0) {
        data['chainID'] = `/ ต่อ Job NO:${temp[0]['jobID']}`
      }
    } else {
      data['chainID'] = ``
    }

    // console.log(data)
    if (data['description']) {

      Object.values(data['description']).sort((a, b) => {
        if (a) {
          if (b) {
            // console.log(a['riceTypeID'] > b['riceTypeID'])
            if (a['riceTypeID'] < b['riceTypeID']) {
              return -1
            }
            if (a['riceTypeID'] > b['riceTypeID']) {
              return 1
            }
            else {
              return 0
            }
          }
        }
      })
      if (data['surveyLocateName'].indexOf('ลาดกระบัง') == -1 && data['surveyLocateName'].indexOf('ท่าเรือคลองเตย') == -1) {
        let godownName = this.sameName(`${data['surveyLocateName']}-${data['surveyProvince']}`)
        surveyName.push(hashCode(godownName))
      } else {
        surveyName.push(hashCode(`${idx}`))
        // console.log('skip as 1')
      }
      // console.log(data)
      // Object.values(data['description']).map((dataDescription) => {
      //   // console.log(dataDescription)
      //   if (dataDescription != null && typeof dataDescription == 'object') {
      //     // console.log(data,idx)
      //     riceDescriptionArr = {
      //       ...riceDescriptionArr,
      //       [idx]: {
      //         ...riceDescriptionArr[idx],
      //       }
      //     }
      //     riceDescriptionArr = {
      //       ...riceDescriptionArr,
      //       [idx]: {
      //         ...riceDescriptionArr[idx],
      //         [dataDescription['riceTypeID']]: (() => {
      //           if (riceDescriptionArr[idx]) {
      //             if (!riceDescriptionArr[idx][dataDescription['riceTypeID']]) {
      //               return (Math.round(parseFloat(dataDescription['quantity']) * 1000) / 1000).toFixed(4)
      //             } else {
      //               return (parseFloat(dataDescription['quantity']) + parseFloat(riceDescriptionArr[idx][dataDescription['riceTypeID']])).toFixed(4)
      //             }
      //           }
      //         })(),
      //         [`Total${dataDescription['riceTypeID']}`]: (() => {
      //           if (riceDescriptionArr[idx]) {
      //             if (!riceDescriptionArr[idx][`Total${dataDescription['riceTypeID']}`]) {
      //               return 1
      //             } else {
      //               return 1 + (riceDescriptionArr[idx][`Total${dataDescription['riceTypeID']}`])
      //             }
      //           }
      //         })()
      //       }
      //     }
      //   }
      // })
    }
  })

  var colors = ['#FFAACC', '#FFCCCC', '#FFFFCC', '#CCAAFF',
    '#CCDDFF', '#CCFFEE', '#CCDDDD', '#CCFFCC', 'fuchsia', 'lime', 'red', 'maroon']
  // // console.log(surveyName)

  function hashCode(s) {
    return s.split("").reduce(function (a, b) { a = ((a << 5) - a) + b.charCodeAt(0); return a & a }, 0);
  }
  function findDup(arr) {
    var duplicates = {}
    for (var i = 0; i < arr.length; i++) {
      if (duplicates.hasOwnProperty(arr[i])) {
        duplicates[arr[i]].push(i);
      } else if (arr.lastIndexOf(arr[i]) !== i) {
        duplicates[arr[i]] = [i];
      }
    }
    return duplicates;
  }

  let pairLocation = findDup(surveyName)
  let depColorSet = {}

  // Object.values(pairLocation).map((ignoreData, idx) => {
  //   ignoreData.map((data) => {
  //     depColorSet = {
  //       ...depColorSet,
  //       [data]: colors[idx]
  //     }
  //   })
  // })
  // console.log(depColorSet)
  return { '0': arr, '1': riceDescriptionArr, '2': depColorSet }
}

module.exports.sameName = (godownName) => {
  if (godownName == 'ชวิน เอ็กซ์ปอร์ต-นครสวรรค์' || godownName == 'เค. วี. ซี. ไร้ซ์ อินเตอร์เทรด-นครสวรรค์' || godownName == 'นครสวรรค์โรงสีไฟไทยรุ่งเรือง (2002)-นครสวรรค์') {
    return 'ชวิน เอ็กซ์ปอร์ต-นครสวรรค์'
  }
  else if (godownName == 'โตมี ฟูดส์ แอนด์โปรดักส์-ปทุมธานี' || godownName == 'โตมีอินเตอร์เทรด-ปทุมธานี' || godownName == 'โมสต์ อินเตอร์เนชั่นแนล-ปทุมธานี' || godownName == 'โตมีฟูดส์แอนด์โปรดักส์-ปทุมธานี') {
    return 'โตมี ฟูดส์ แอนด์โปรดักส์-ปทุมธานี'
  }
  else if (godownName == 'เต็กรุ่งเรืองพาณิชย์-สุพรรณบุรี' || godownName == 'แฟนซีไรซ์-สุพรรณบุรี') {
    return 'เต็กรุ่งเรืองพาณิชย์-สุพรรณบุรี'
  }
  else if (godownName == 'ดับบลิว แอนด์ พี เอ็กซ์ปอร์ต-พระนครศรีอยุธยา' || godownName == 'ชัยประสิทธิ์พืชผล-พระนครศรีอยุธยา' || godownName == 'วิริยะโรจน์-อยุธยา') {
    return 'ดับบลิว แอนด์ พี เอ็กซ์ปอร์ต-พระนครศรีอยุธยา'
  }
  else if (godownName == 'ข้าวสิริมงคล-นครราชสีมา' || godownName == 'นครราชสีมา ศิริโชคชัย-นครราชสีมา') {
    return 'ข้าวสิริมงคล-นครราชสีมา'
  }
  else if (godownName == 'ที.เค. ไรซ์มิลล์ แอนด์ แอช-นครปฐม' || godownName == 'ธัญญกิจ นครปฐม (2521)-นครปฐม') {
    return 'ที.เค. ไรซ์มิลล์ แอนด์ แอช-นครปฐม'
  }
  else if (godownName == 'พิมานโกลเด้นไรซ์-กรุงเทพฯ' || godownName == 'พิมานวรกิจ (1999)-กรุงเทพฯ') {
    return 'พิมานโกลเด้นไรซ์-กรุงเทพฯ'
  }
  else if (godownName == 'สยามโกลเด้นไรซ์-สระบุรี' || godownName == 'โชคฉัตรไชยไรซ์มิล-สระบุรี') {
    return 'สยามโกลเด้นไรซ์-สระบุรี'
  }
  else if (godownName == 'กรุงไทยพืชผล-สมุทรปราการ' || godownName == 'ไชยพรไรซแอนด์ฟู้ดโปรดักส์-สมุทรปราการ') {
    return 'กรุงไทยพืชผล-สมุทรปราการ'
  }
  else if (godownName == 'ข้าวบัวทิพย์ มาร์เก็ตติ้ง-ขอนแก่น' || godownName == 'เค.ซี. โกลเด้นไร้ซ์-ขอนแก่น') {
    return 'ข้าวบัวทิพย์ มาร์เก็ตติ้ง-ขอนแก่น'
  }
  else if (godownName == 'วิงออนไรซ์ เทรดดิ้ง-ปทุมธานี' || godownName == 'ที.ที.เอส. ไรซ์-ปทุมธานี') {
    return 'วิงออนไรซ์ เทรดดิ้ง-ปทุมธานี'
  }
  else if (godownName == 'เพิ่มลาภ-สิงห์บุรี' || godownName == 'รวมใจเจริญทรัพย์-สิงห์บุรี') {
    return 'รวมใจเจริญทรัพย์-สิงห์บุรี'
  }
  else if (godownName == 'ธนกรบรรจงสรร-พิจิตร' || godownName == 'ทีบีเอส ไรซ์มิลล์-พิจิตร') {
    return 'ธนกรบรรจงสรร-พิจิตร'
  }
  else if (godownName == 'ธัญญไรซ์ (ไทยแลนด์)-สมุทรปราการ' || godownName == 'สเปเชียล ไรซ์-สมุทรปราการ') {
    return 'ธัญญไรซ์ (ไทยแลนด์)-สมุทรปราการ'
  }
  else if (godownName == 'วัจนสุรัตน์-ฉะเชิงเทรา' || godownName == 'วิวัฒนาพืชผล-ฉะเชิงเทรา') {
    return 'วัจนสุรัตน์-ฉะเชิงเทรา'
  }
  else if (godownName == 'สุชินการเกษตร-สุพรรณบุรี' || godownName == 'โปรเกรสซีเรียล-สุพรรณบุรี') {
    return 'สุชินการเกษตร-สุพรรณบุรี'
  }
  else {
    return godownName
  }
}
module.exports.evalSurveyRequest = (viewAllSurveyRequestSheetByDate, RequestJobComplete) => {
  let arr = []
  Object.keys(viewAllSurveyRequestSheetByDate).map((title) => {
    if (title !== 'countJobID') {
      if (typeof viewAllSurveyRequestSheetByDate[title] == 'object' && !RequestJobComplete['message']) {
        if (!viewAllSurveyRequestSheetByDate['message']) {
          let temp = Object.values(RequestJobComplete).filter((e) => { return e['requestID'] == viewAllSurveyRequestSheetByDate[title]['requestID'] })
          // console.log(temp)
          if (temp.length != 0) {
            viewAllSurveyRequestSheetByDate[title]['jobID'] = temp[0]['jobID']
            viewAllSurveyRequestSheetByDate[title]['officerName'] = ''
            viewAllSurveyRequestSheetByDate[title]['officerName'] = temp[0]['officerID']
            if (temp[0]?.['officerID2']) {
              viewAllSurveyRequestSheetByDate[title]['officerName2'] = ''
              viewAllSurveyRequestSheetByDate[title]['officerName2'] = temp[0]['officerID2']
            }

            // console.log(viewAllSurveyRequestSheetByDate[title])
            arr = arr.concat([viewAllSurveyRequestSheetByDate[title]])
          } else {
            viewAllSurveyRequestSheetByDate[title]['officerID'] = ''
          }
        }
      }
    }
  })
  return arr
}

module.exports.evalCheckWeight = (viewAllCheckWeightComplete, arr) => {
  let newObjArr = []
  Object.keys(arr).map((title) => {
    if (title !== 'countJobID') {
      if (typeof arr[title] == 'object' && !viewAllCheckWeightComplete?.message) {
        if (!arr['message']) {
          let temp = []
          if (viewAllCheckWeightComplete) {
            temp = Object.values(viewAllCheckWeightComplete).filter((e) => {
              return e['jobID'] == arr[title]['jobID']
            })
          }
          if (temp.length != 0) {
            Object.values(arr[title]['description']).map((descriptionData) => {
              temp.map((tempData) => {
                if (tempData['licenseID'] == descriptionData['licenseID'] && tempData['subID'] == descriptionData['subID']) {
                  descriptionData['isComplete'] = true
                  Object.keys(tempData).map((tempDataKey) => {

                    if (tempDataKey == 'quantity') {
                      tempData[tempDataKey] /= 1000
                    }
                    descriptionData[tempDataKey] = tempData[tempDataKey]
                  })
                }
              })
            })
            // arr[title]['jobID'] = temp[0]['jobID']
            arr[title]['checkWeightDescription'] = temp
            newObjArr = newObjArr.concat([arr[title]])
          } else {
            arr[title]['officerID'] = ''
          }
        }
      }
    }
  })
  return newObjArr
}

module.exports.directConvert = (riceTitle) => {
  let output = ''
  riceTitle = riceTitle.replaceAll('%', '').replaceAll(" ","").replaceAll("(","").replaceAll(")","")


  Object.keys(pairData).map((title) => {
    if (riceTitle == title.toUpperCase() ) {
      // console.log(pairData[title]['EN'])
      output = pairData[title]['EN']
      return true
    }
  })
  if(output == ''){
    console.log(riceTitle)
  }

  return output.toUpperCase()
}